import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const createSkuAccessoryMaterial = createAsyncThunk('createSkuAccessoryMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/create-sku-material/UI/product_accessories`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getAccessoryMaterial = createAsyncThunk('getAccessoryMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/get-materials/product_accessories`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});